export const customPriorityBadgeColor = (
  priorities: any,
  priorityId: number,
) => {
  return {
    background: priorities?.find((item: any) => item.id === priorityId)?.color,
  };
};
